__turbopack_context__.v({
  "caption": "WzQh2G_caption",
  "lead": "WzQh2G_lead",
  "media": "WzQh2G_media",
  "root": "WzQh2G_root",
  "slide": "WzQh2G_slide",
  "stage": "WzQh2G_stage",
  "thumb": "WzQh2G_thumb",
  "thumbs": "WzQh2G_thumbs",
});
